import React, {useEffect, useState} from "react";
import "./style.scss";
import {createTheme, MuiThemeProvider} from "@material-ui/core/styles";

export default function Direction({direction, children, isApplyToBody}) {
    const [muiTheme, setMuiTheme] = useState();

    useEffect(() => {
        if (direction)
            setMuiTheme(createTheme({
                direction: direction,
                typography: {
                    fontFamily: `'Assistant', sans-serif`,
                    useNextVariants: true,
                    suppressDeprecationWarnings: true
                }
            }));
        else
            setMuiTheme(null);

        if (isApplyToBody)
            document.body.style.direction = direction;
    }, [direction]);

    if (!muiTheme)
        return null;

    return (
        <MuiThemeProvider theme={muiTheme}>
            <div className={"direction " + (direction === "rtl" ? "direction-rtl" : "direction-ltr")}>
                {children}
            </div>
        </MuiThemeProvider>
    );
}